// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_count_VIEWS_FROM_created_date = ["%(count)s zobrazenie od %(created_date)s", "%(count)s zobrazenia od %(created_date)s", "%(count)s zobrazen\u00ed od %(created_date)s"];
export const BZ2_REFRESHED = "Aktualizovan\u00fd";
export const BZ2_STAR_IT = "Ulo\u017e";
export const BZ2_STARRED_NR = "ulo\u017een\u00e9";
export const BZ2_UNSTAR_IT = "Odstr\u00e1\u0148";
export const SHOW_PRICE_HISTORY = "Hist\u00f3ria ceny";
